import { useEffect } from 'react';

/**
 * ThemeProvider - Aplica los colores personalizados del cliente al backoffice
 * Los colores se obtienen de la configuración de la empresa y se aplican como CSS variables
 */
const ThemeProvider = ({ children }) => {
  useEffect(() => {
    // No cargar tema aquí - el Header se encarga de eso
    // Solo establecer valores por defecto iniciales
    const root = document.documentElement;
    root.style.setProperty('--primary-color', '#2563EB');
    root.style.setProperty('--primary-font-color', '#FFFFFF');
    root.style.setProperty('--header-footer-bg', '#ffffff');
    root.style.setProperty('--header-footer-font', '#000000');

    // Escuchar evento personalizado para actualizar el tema
    const handleThemeUpdate = (event) => {
      const { primaryColor, fontPrimaryColor, headerFooterColor, fontHeaderFooterColor } = event.detail;
      const root = document.documentElement;
      
      if (primaryColor) root.style.setProperty('--primary-color', primaryColor);
      if (fontPrimaryColor) root.style.setProperty('--primary-font-color', fontPrimaryColor);
      if (headerFooterColor) root.style.setProperty('--header-footer-bg', headerFooterColor);
      if (fontHeaderFooterColor) root.style.setProperty('--header-footer-font', fontHeaderFooterColor);
      
    };
    
    window.addEventListener('themeUpdated', handleThemeUpdate);
    
    return () => {
      window.removeEventListener('themeUpdated', handleThemeUpdate);
    };
  }, []);

  return children;
};

export default ThemeProvider;

